import { Box, createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import "./App.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperType } from "swiper";
import "swiper/css";
import { Mousewheel } from "swiper/modules";

import Intro from "./pages/stability/Intro";
import WhatIsStability from "./pages/stability/WhatIsStability";
import WhatIsSarodi from "./pages/sarodi";
import ProductEffect1 from "./pages/sarodiProductEffects/page1";
import ProductEffect2 from "./pages/sarodiProductEffects/page2";
import ProductEffect3 from "./pages/sarodiProductEffects/page3";
import Rebranding from "./pages/rebranding";
import ProductionDesign from "./pages/productionDesign";
import IntroPage from "./pages/introPage";
import NavBar from "./components/navbar";
import { useRef, useState } from "react";
import HomePageAnimation from "./components/homePageAnimation";
import FooterPage from "./pages/footer";
import SlideWrapper from "./components/helpers/SlideWrapper";

const theme = createTheme({
  typography: {
    fontFamily: [
      "Anjoman", // Replace with the name of your custom font
      "Roboto", // Default Material-UI font
      '"Helvetica Neue"', // Fallback font
      "Arial", // Fallback font
      "sans-serif", // Fallback font
    ].join(","),
    fontWeightRegular: 400, // FontWeight for regular font
    fontWeightBold: 700, // FontWeight for bold font
  },
});

function App() {
  const swiperRef = useRef<SwiperType | null>(null);
  const [currentSwiperIndex, setCurrentSwiperIndex] = useState<number>(0);

  const handleClickToTop = () => {
    swiperRef.current && swiperRef.current.slideTo(1);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <HomePageAnimation />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            transition: "all .5s ",
            zIndex: "10",
            right: currentSwiperIndex === 9 ? "-10rem" : "0",
            position: "fixed",
          }}
        >
          <NavBar swiper={swiperRef.current} activeIndex={currentSwiperIndex} />
        </Box>
        <Box
          sx={{
            position: "absolute",
            height: "100%",
            display: "flex",
          }}
        >
          <Swiper
            onSwiper={(swiper: SwiperType) => {
              swiperRef.current = swiper;
            }}
            onSlideChange={(swiper: SwiperType) => {
              setCurrentSwiperIndex(swiper.realIndex);
            }}
            direction="vertical"
            slidesPerView={1}
            spaceBetween={40}
            modules={[Mousewheel]}
            speed={1000}
            mousewheel={{
              sensitivity: 1,
              thresholdDelta: 1,
              eventsTarget: "container",
            }}
          >
            {/* What Is Stability Pages */}
            <SwiperSlide>
              <IntroPage />
            </SwiperSlide>
            <SwiperSlide>
              <Intro />
            </SwiperSlide>
            <SwiperSlide
              style={{
                maxWidth: "1920px",
              }}
            >
              <WhatIsStability />
            </SwiperSlide>

            {/* What Is Sarodi*/}
            <SwiperSlide
              style={{
                maxWidth: "1920px",
              }}
            >
              <WhatIsSarodi />
            </SwiperSlide>

            {/* Product Effect Pages */}
            <SwiperSlide
              style={{
                maxWidth: "1920px",
              }}
            >
              <ProductEffect1 />
            </SwiperSlide>
            <SwiperSlide
              style={{
                maxWidth: "1920px",
              }}
            >
              <ProductEffect2 />
            </SwiperSlide>
            <SwiperSlide
              style={{
                maxWidth: "1920px",
              }}
            >
              <ProductEffect3 />
            </SwiperSlide>

            {/* Rebranding Page */}
            <SwiperSlide
              style={{
                maxWidth: "1920px",
              }}
            >
              <Rebranding />
            </SwiperSlide>

            {/* Production Design Page */}
            <SwiperSlide
              style={{
                maxWidth: "1920px",
              }}
            >
              <ProductionDesign onClickToTop={handleClickToTop} />
            </SwiperSlide>

            {/* Footer Page */}
            <SwiperSlide>
              <FooterPage />
            </SwiperSlide>
          </Swiper>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default App;
